class SearchBox {
    constructor(containerId) {
        this.container = document.getElementById(containerId);
        this.uiSearch = this.container.querySelector('.ui-search');
        this.filterWidget_delayMs = 2000;

        this.serverData = {
            resultsUrl: this.container.querySelector('[data-sf-role="resultsUrl"]').value,
            resultsUrlSection: this.container.querySelector('[data-sf-role="resultsUrlSection"]')?.value,
            indexCatalogue: this.container.querySelector('[data-sf-role="indexCatalogue"]').value,
            wordsMode: this.container.querySelector('[data-sf-role="wordsMode"]').value,
            disableSuggestions: JSON.parse(this.container.querySelector('[data-sf-role="disableSuggestions"]').value),
            minSuggestionLength: this.container.querySelector('[data-sf-role="minSuggestionLength"]').value,
            suggestionFields: this.container.querySelector('[data-sf-role="suggestionFields"]').value,
            language: this.container.querySelector('[data-sf-role="language"]').value,
            suggestionsRoute: this.container.querySelector('[data-sf-role="suggestionsRoute"]').value,
            searchTextBoxSelector: this.container.querySelector('[data-sf-role="searchTextBoxId"]')?.value,
            searchTextBoxFacetSelector: this.container.querySelector('[data-sf-role="searchTextBoxFacetId"]')?.value,
        };

        if (this.serverData.searchTextBoxFacetSelector) {
            this.searchTextBoxFacet = document.getElementById(this.serverData.searchTextBoxFacetSelector);

            var searchQuery = window.QueryStringHelper.getQueryStringParameter('searchQuery');
            if (searchQuery) {
                setTimeout(() => {
                    this.searchTextBoxFacet.focus();
                    this.searchTextBoxFacet.value = '';
                    this.searchTextBoxFacet.value = searchQuery;
                }, 200);
                this.container.querySelector('#filter-search-facet-button').classList.add('do-not-show');
                this.container.querySelector('#filter-search-facet-clear').classList.remove('do-not-show');
            }
        } else {
            if (this.serverData.searchTextBoxSelector) {
                this.searchTextBox = document.getElementById(this.serverData.searchTextBoxSelector);
                this.mobileSearchTextBox = document.getElementById('mobile-' + this.serverData.searchTextBoxSelector);
            }

            if (!this.searchTextBox) {
                return;
            }
        }

        this.attachEvents();
    }

    attachEvents() {
        if (this.container.querySelector('.expand')) {
            this.container.getElementsByClassName('expand')[0].addEventListener('click', (e) => {
                this.openSearch(e);
            });

            this.container.getElementsByClassName('close')[0].addEventListener('click', (e) => {
                this.closeSearch();
            });
        } else {
            if (this.container.querySelector('button')) {
                this.container.getElementsByTagName('button')[0].addEventListener('click', (e) => {
                    this.navigateToResults(e);
                });
            }
            else {
                this.container.querySelector('#filter-search-facet-button').addEventListener('click', (e) => {
                    this.navigateToResults(e);
                });

                this.container.querySelector('#filter-search-facet-clear').addEventListener('click', (e) => {
                    this.container.querySelector('#filter-search-facet-button').classList.remove('do-not-show');
                    this.container.querySelector('#filter-search-facet-clear').classList.add('do-not-show');
                    this.searchTextBoxFacet = '';
                    window.location = this.getLocation('');
                });
            }
        }

        if (this.container.querySelector('.mobile-search')) {
            this.container.getElementsByClassName('mobile-search')[0].addEventListener('click', (e) => {
                this.navigateToResults(e);
            });
        }

        this.searchTextBox?.addEventListener('keypress', (ev) => {
            this.keypressHandler(ev);
        });

        this.searchTextBoxFacet?.addEventListener('keypress', (ev) => {
            this.keypressHandler(ev);
        });

        this.searchTextBoxFacet?.addEventListener('keyup', (ev) => {
            if (ev.keyCode === 13) {
                ev.preventDefault();
                setTimeout(() => {
                    this.searchFieldUpdated(ev);
                }, this.filterWidget_delayMs);
            } else {
                if (!ev)
                    ev = window.ev;

                if (ev.stopPropagation) {
                    ev.stopPropagation();
                }
                else {
                    ev.cancelBubble = true;
                }

                if (ev.preventDefault) {
                    ev.preventDefault();
                }
                else {
                    ev.returnValue = false;
                }

                setTimeout(() => {
                    this.searchFieldUpdated(ev);
                }, this.filterWidget_delayMs);
            }
        });

        this.searchTextBoxFacet?.addEventListener('paste', (ev) => {
            setTimeout(() => {
                this.searchFieldUpdated(ev);
            }, this.filterWidget_delayMs);
        });
    }

    searchFieldUpdated(e) {
        if (e.target && e.target.value.length > 2) {
            this.navigateToResults(e);
        }
    }

    openSearch(e) {
        if (DomHelper.hasClass('expanded', this.uiSearch)) {
            this.navigateToResults(e);
        } else {
            this.uiSearch.classList.add('expanded');
        }
    }

    closeSearch() {
        this.uiSearch.classList.remove('expanded');
    }

    keypressHandler(e) {
        if (!e)
            e = window.event;

        var keyCode = null;
        if (e.keyCode) {
            keyCode = e.keyCode;
        }
        else {
            keyCode = e.charCode;
        }

        if (keyCode == 13) {
            this.navigateToResults(e);
        }
    }

    navigateToResults(e) {
        if (!e)
            e = window.event;

        if (e.stopPropagation) {
            e.stopPropagation();
        }
        else {
            e.cancelBubble = true;
        }
        if (e.preventDefault) {
            e.preventDefault();
        }
        else {
            e.returnValue = false;
        }

        var query = e.target.value;

        if (query && query.trim() && this.serverData.indexCatalogue) {
            this.sendSentence();
            window.location = this.getLocation(query);
        } else {
            window.location = this.getLocation(query);
        }
    }

    getLocation(input) {
        var query = input.trim();

        var separator = (this.serverData.resultsUrl.indexOf('?') == -1) ? '?' : '&';

        var catalogueParam = separator + 'indexCatalogue=' + encodeURIComponent(this.serverData.indexCatalogue),
            searchQueryParam = '&searchQuery=' + encodeURIComponent(query),
            wordsModeParam = '&wordsMode=' + this.serverData.wordsMode,
            section = this.serverData.resultsUrlSection ? '#' + this.serverData.resultsUrlSection : '';

        var url = this.serverData.resultsUrl + catalogueParam + searchQueryParam + wordsModeParam + section;

        // Check if filter parameters exist, if so retain them in the URL
        var currentUrlParams = new URLSearchParams(window.location.search);
        if (currentUrlParams.has('filter')) {
            currentUrlParams.delete('page');
            url = url + '&filter=' + currentUrlParams.get('filter');
        }

        return url;
    }

    sendSentence() {
        if (window.DataIntelligenceSubmitScript) {
            DataIntelligenceSubmitScript._client.sentenceClient.writeSentence({
                predicate: 'Search for',
                object: this.searchTextBoxFacet ? this.searchTextBoxFacet.value : this.searchTextBox.value,
                objectMetadata: [{
                    'K': 'PageUrl',
                    'V': location.href
                }]
            });
        }
    }
}

export default SearchBox;